(function () {
  function initializePacificaHome() {
    const page = document.querySelector('main .pacifica-page');
    if (!page) return;
    if (window.__pacificaHomeController) window.__pacificaHomeController.abort();
    const controller = new AbortController();
    const signal = controller.signal;
    window.__pacificaHomeController = controller;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const heroWidthScroll = page.querySelector('#heroWidthScroll');
    const categoriesInner = page.querySelector('#categories > div');
    let heroWidthFrame;

    function updateHeroWidth() {
      heroWidthFrame = undefined;
      if (!heroWidthScroll || !categoriesInner || window.innerWidth < 768) return;
      const targetWidth = categoriesInner.getBoundingClientRect().width;
      const initialWidth = Math.min(2000, targetWidth);
      const scrollDistance = Math.min(520, window.innerHeight * 0.52);
      const progress = reduceMotion.matches ? 1 : Math.min(1, Math.max(0, window.scrollY / scrollDistance));
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      heroWidthScroll.style.maxWidth = `${initialWidth + (targetWidth - initialWidth) * easedProgress}px`;
    }

    function requestHeroWidthUpdate() {
      if (heroWidthFrame !== undefined) return;
      heroWidthFrame = requestAnimationFrame(updateHeroWidth);
    }

    updateHeroWidth();
    window.addEventListener('scroll', requestHeroWidthUpdate, { passive: true, signal: signal });
    window.addEventListener('resize', requestHeroWidthUpdate, { signal: signal });
    reduceMotion.addEventListener('change', requestHeroWidthUpdate, { signal: signal });

    const rail = page.querySelector('#productRail');
    const nextProduct = page.querySelector('#nextProduct');
    const prevProduct = page.querySelector('#prevProduct');
    const progressTrack = page.querySelector('#productProgressTrack');
    const progressThumb = page.querySelector('#productProgressThumb');
    if (rail && nextProduct && prevProduct && progressTrack && progressThumb) {
      const updateProductProgress = function () {
        const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const visibleRatio = rail.scrollWidth ? Math.min(1, rail.clientWidth / rail.scrollWidth) : 1;
        const thumbRatio = Math.max(0.12, visibleRatio);
        const progress = maxScroll ? rail.scrollLeft / maxScroll : 0;
        const trackWidth = progressTrack.clientWidth;
        const thumbWidth = trackWidth * thumbRatio;
        progressThumb.style.width = `${thumbRatio * 100}%`;
        progressThumb.style.transform = `translateX(${progress * Math.max(0, trackWidth - thumbWidth)}px)`;
        progressTrack.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
        prevProduct.disabled = progress <= 0.001;
        nextProduct.disabled = progress >= 0.999;
        prevProduct.classList.toggle('opacity-35', prevProduct.disabled);
        nextProduct.classList.toggle('opacity-35', nextProduct.disabled);
      };
      const moveProductRail = function (direction) {
        rail.scrollBy({ left: direction * Math.max(280, rail.clientWidth * 0.8), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };
      nextProduct.addEventListener('click', function () { moveProductRail(1); }, { signal: signal });
      prevProduct.addEventListener('click', function () { moveProductRail(-1); }, { signal: signal });
      rail.addEventListener('scroll', updateProductProgress, { passive: true, signal: signal });
      window.addEventListener('resize', updateProductProgress, { signal: signal });
      progressTrack.addEventListener('click', function (event) {
        const bounds = progressTrack.getBoundingClientRect();
        const target = Math.min(1, Math.max(0, (event.clientX - bounds.left) / bounds.width));
        rail.scrollTo({ left: target * (rail.scrollWidth - rail.clientWidth), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }, { signal: signal });
      progressTrack.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        moveProductRail(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal: signal });
      updateProductProgress();
    }

    const toast = page.querySelector('#toast');
    const cartCount = page.querySelector('#cartCount');
    const cartButton = page.querySelector('#cartButton');
    let toastTimer;
    page.querySelectorAll('.pacifica-product-form').forEach(function (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        const button = form.querySelector('.add-to-cart');
        if (!button || button.disabled) return;
        button.disabled = true;
        try {
          const shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const response = await fetch(shopRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Unable to add product');
          const cart = await fetch(shopRoot + 'cart.js').then(function (result) { return result.json(); });
          if (cartCount && cartButton) {
            cartCount.textContent = cart.item_count;
            cartCount.classList.remove('hidden');
            cartCount.classList.add('grid');
            cartButton.setAttribute('aria-label', `Shopping bag, ${cart.item_count} items`);
          }
          if (toast) {
            toast.textContent = `${button.dataset.product} added to your bag`;
            toast.classList.remove('translate-y-24', 'opacity-0');
            clearTimeout(toastTimer);
            toastTimer = setTimeout(function () { toast.classList.add('translate-y-24', 'opacity-0'); }, 2200);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        } catch (error) {
          if (toast) {
            toast.textContent = 'This item could not be added. Please try again.';
            toast.classList.remove('translate-y-24', 'opacity-0');
          }
        } finally {
          button.disabled = false;
        }
      }, { signal: signal });
    });

    const lookCards = Array.from(page.querySelectorAll('[data-look-card]'));
    let activeLook = null;

    function closeLook(card, restoreFocus) {
      if (!card) return;
      const trigger = card.querySelector('[data-look-open]');
      const panel = card.querySelector('[data-look-panel]');
      card.classList.remove('is-look-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
      }
      if (activeLook === card) activeLook = null;
      if (restoreFocus && trigger) trigger.focus();
    }

    function openLook(card) {
      if (!card) return;
      if (activeLook && activeLook !== card) closeLook(activeLook, false);
      const trigger = card.querySelector('[data-look-open]');
      const panel = card.querySelector('[data-look-panel]');
      const closeButton = card.querySelector('[data-look-close]');
      card.classList.add('is-look-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.setAttribute('aria-hidden', 'false');
        panel.removeAttribute('inert');
      }
      activeLook = card;
      if (closeButton) closeButton.focus({ preventScroll: true });
    }

    lookCards.forEach(function (card) {
      const trigger = card.querySelector('[data-look-open]');
      const closeButton = card.querySelector('[data-look-close]');
      if (trigger) trigger.addEventListener('click', function () { openLook(card); }, { signal: signal });
      if (closeButton) closeButton.addEventListener('click', function () { closeLook(card, true); }, { signal: signal });
      card.addEventListener('click', function (event) {
        if (card.classList.contains('is-look-open') && !event.target.closest('[data-look-panel], [data-look-open]')) closeLook(card, true);
      }, { signal: signal });
    });

    document.addEventListener('keydown', function (event) {
      if (!activeLook) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLook(activeLook, true);
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(activeLook.querySelectorAll('[data-look-panel] a[href], [data-look-panel] button:not([disabled])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, { signal: signal });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePacificaHome);
  else initializePacificaHome();
  document.addEventListener('shopify:section:load', function () {
    initializePacificaHome();
  });
})();
